module.exports = __webpack_public_path__ + "static/media/1606734516644.a890f7c5.jpg";